import React from "react"
import { useBuildData } from "../hooks/use-build-data"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import {
  rgpdContainer,
  rgpdTitle,
  rgpdSubTitle,
} from "../styles/rgpd.module.scss"
import {
  Title,
  H1Title,
  Container,
} from "../styled-components/mentions-legales-styled"
import Ariane from "../components/Ariane/ariane"
import Obfuscate from "react-obfuscate"
import PropTypes from "prop-types"
import ContentTransformer from "../components/Transformers/content-transformer"

const Rgpd = ({ arianeDisplayed }) => {
  const data = useBuildData()
  return (
    <Layout message="Règlement général sur la protection des données">
      <SEO
        description="Sur cette page vous retrouvez les mentions relatives à l'utilisation de données personnelles"
        title="Règlement général sur la protection des données"
      />
      {arianeDisplayed && (
        <Ariane
          pageName="Règlement général sur la protection des données"
          isListing={true}
        />
      )}
      <Container className={rgpdContainer}>
        <H1Title className={rgpdTitle}>
          Mentions relatives à l&apos;utilisation de données personnelles
        </H1Title>
        <p>
          Le site est essentiellement destiné à la diffusion des informations
          portant sur l’actualité de la collectivité. Dans ce cadre, certains
          traitements de données à caractère personnel sont réalisés.
        </p>
        {data.rgpd_settings.list_treatments.value !== "" && (
          <ContentTransformer
            content={data.rgpd_settings.list_treatments.value}
          />
        )}
        <Title className={rgpdSubTitle}>Responsable du traitement</Title>
        <p>
          Le responsable du traitement des données à caractère personnel est{" "}
          <b>{data.rgpd_settings.data_manager}</b>. Il peut être contacté de la
          manière suivante :
        </p>
        <ul>
          <li>
            Téléphone :{" "}
            <b>
              <Obfuscate tel={data.rgpd_settings.phone_data_manager} />
            </b>
          </li>
          <li>
            E-mail :{" "}
            <b>
              <Obfuscate email={data.rgpd_settings.mail_data_manager} />
            </b>
          </li>
        </ul>
        <Title className={rgpdSubTitle}>
          Délégué à la Protection des Données
        </Title>
        <p>
          La personne suivante a été nommée Délégué à la Protection des Données
          : <b>{data.rgpd_settings.delegated_data_protection}</b>. Elle peut
          être contactée de la manière suivante :
        </p>
        <ul>
          <li>
            Téléphone :{" "}
            <b>
              <Obfuscate tel={data.rgpd_settings.phone_data_protection} />
            </b>
          </li>
          <li>
            E-mail :{" "}
            <b>
              <Obfuscate email={data.rgpd_settings.mail_data_protection} />
            </b>
          </li>
        </ul>
        <Title className={rgpdSubTitle}>
          Droits concernant vos données à caractère personnel:
        </Title>
        <ul>
          <li>
            Le <b>droit d&apos;obtenir des informations</b> sur les données que
            nous détenons sur vous et les traitements mis en œuvre ;
          </li>
          <li>
            Lorsque le traitement est fondé sur votre consentement, vous avez le{" "}
            <b>droit de retirer ce consentement à tout moment</b>. Cette action
            ne portera pas atteinte à la licéité du traitement fondé sur le
            consentement effectué avant le retrait de celui-ci ;
          </li>
          <li>
            Dans certaines circonstances, le
            <b>droit de recevoir des données sous forme électronique</b> et/ou
            de nous demander de transmettre ces informations à un tiers lorsque
            cela est techniquement possible (veuillez noter que ce droit
            n&apos;est applicable qu&apos;aux données que vous nous avez
            fournies) ;
          </li>
          <li>
            Le <b>droit de modifier ou corriger vos données</b> (veuillez noter
            que des dispositions légales ou réglementaires ou des raisons
            légitimes peuvent limiter ce droit) ;
          </li>
          <li>
            Le <b>droit de demander la suppression de vos données</b> dans
            certaines circonstances (veuillez noter que des dispositions légales
            ou réglementaires ou des raisons légitimes peuvent nous imposer de
            conserver ces données) ;
          </li>
          <li>
            Le
            <b>
              droit de demander de restreindre ou de vous opposer au traitement
              de vos données
            </b>
            , dans certaines circonstances ;
          </li>
          <li>
            Vous disposez également du
            <b>
              droit de déposer une réclamation auprès de la Commission Nationale
              de l’Informatique et des Libertés
            </b>
            . Pour cela, merci d&apos;adresser un courrier à l&apos;adresse
            suivante : CNIL – 3 Place de Fontenoy – TSA 80715 – 75334 Paris –
            Cedex 07.
          </li>
        </ul>
        <p style={{ marginBottom: "0.5rem" }}>
          Pour exercer vos droits en matière de protection des données
          personnelles, vous pouvez prendre contact avec{" "}
          <b>{data.rgpd_settings.delegated_data_protection}</b>.
        </p>
        <p>Ou faire la demande auprès de notre collectivité à partir de :</p>
        <ul>
          <li>
            Téléphone :{" "}
            <b>
              <Obfuscate tel={data.rgpd_settings.phone_data_protection} />
            </b>
          </li>
          <li>
            E-mail :{" "}
            <b>
              <Obfuscate email={data.rgpd_settings.mail_data_protection} />
            </b>
          </li>
        </ul>
      </Container>
    </Layout>
  )
}

Rgpd.propTypes = {
  arianeDisplayed: PropTypes.bool,
}

export default Rgpd
